import React from "react";

function MentalHealthGame() {
	return (
		<div style={{ width: "100%", height: "100vh" }}>
			<iframe
				src="https://rococo-gnome-aba18f.netlify.app/"
				title="Mental Health Game"
				style={{
					width: "100%",
					height: "90vh",
					border: "none",
					marginTop: "10vh",
				}}
			/>
		</div>
	);
}

export default MentalHealthGame;
